module.exports = __webpack_public_path__ + "3a771f57bfe922d66ac2f239bf7f6b03.svg";